import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { StatusPill } from "@/components/StatusPill";
import { Download, Check, X } from "lucide-react";
import { toast } from "sonner";

export default function FacilityProposals() {
  const [proposals, setProposals] = useState([]);

  const load = () => api.get("/proposals").then((r) => setProposals(r.data));
  useEffect(() => { load(); }, []);

  const respond = async (id, action) => {
    try {
      await api.post(`/proposals/${id}/respond`, { action });
      toast.success(`Proposal ${action}d`);
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-6" data-testid="facility-proposals">
      <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Proposals</h1>
      <div className="grid gap-3">
        {proposals.map((p) => (
          <Card key={p.id} data-testid={`proposal-${p.id}`}>
            <CardContent className="p-5">
              <div className="flex items-start justify-between flex-wrap gap-3">
                <div>
                  <div className="font-bold text-slate-900 text-lg">{p.request?.position} × {p.request?.count}</div>
                  <div className="text-xs text-slate-500">{p.request?.shift_date} · {p.request?.start_time}-{p.request?.end_time}</div>
                  <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
                    <div><div className="text-xs text-slate-500">Subtotal</div><div className="font-semibold">${p.subtotal.toFixed(2)}</div></div>
                    <div><div className="text-xs text-slate-500">HST ({p.tax_rate}%)</div><div className="font-semibold">${p.tax_amount.toFixed(2)}</div></div>
                    <div><div className="text-xs text-slate-500">Total</div><div className="font-bold text-brand-navy text-lg">${p.total.toFixed(2)}</div></div>
                    <div><div className="text-xs text-slate-500">Status</div><StatusPill status={p.status} /></div>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <a href={`${API}/proposals/${p.id}/pdf`} target="_blank" rel="noreferrer">
                    <Button variant="outline" size="sm" data-testid={`proposal-pdf-${p.id}`}><Download className="w-4 h-4 mr-1" />PDF</Button>
                  </a>
                  {p.status === "sent" && (
                    <>
                      <Button size="sm" className="bg-green-600 hover:bg-green-700" onClick={() => respond(p.id, "approve")} data-testid={`proposal-approve-${p.id}`}><Check className="w-4 h-4 mr-1" />Approve</Button>
                      <Button size="sm" variant="outline" className="text-red-600 border-red-200" onClick={() => respond(p.id, "reject")} data-testid={`proposal-reject-${p.id}`}><X className="w-4 h-4 mr-1" />Reject</Button>
                    </>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        {proposals.length === 0 && <div className="text-center py-16 text-slate-500">No proposals yet.</div>}
      </div>
    </div>
  );
}
